import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { policy } from 'src/@order/commonData/policy';
import { terms } from 'src/@order/commonData/terms';

declare var lottie: any;

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
})
export class InfoDialogComponent implements OnInit {
  heading: string;
  infoMessage: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<InfoDialogComponent>,
    private sanitized: DomSanitizer
  ) {
    // get data
    this.heading = this._data.heading;
    // this.infoMessage = _data?.type == 'html' ? this.transform(this._data.message) : this._data.message;
    if (_data?.type == 'terms') {
      this.infoMessage = this.transform(terms);
    } else if (_data?.type == 'policy') {
      this.infoMessage = this.transform(policy);
    } else {
      this.infoMessage = this._data.message;
    }
  }

  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    lottie.loadAnimation({
      container: document.getElementById('success-lottie'), // Your container ID
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'assets/Success.json', // Relative path to your animation file
    });
  }
}
